var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1 14.9999V6.9999H11.9V14.9999H13.1Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 6.9999V14.9999H9.39999V6.9999H10.6Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09999 14.9999V6.9999H6.89999V14.9999H8.09999Z",
    fill: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90757 4.2999C7.0097 2.95741 8.13135 1.8999 9.49999 1.8999H10.5C11.8686 1.8999 12.9903 2.95741 13.0924 4.2999H17V5.4999H16.0619L15.1717 16.6275C15.1052 17.459 14.411 18.0999 13.5768 18.0999H6.4232C5.58902 18.0999 4.89482 17.459 4.8283 16.6275L3.93809 5.4999H3V4.2999H6.90757ZM8.11417 4.2999C8.21122 3.62144 8.7947 3.0999 9.49999 3.0999H10.5C11.2053 3.0999 11.7888 3.62144 11.8858 4.2999H8.11417ZM5.14192 5.4999H14.8581L13.9755 16.5318C13.9589 16.7397 13.7854 16.8999 13.5768 16.8999H6.4232C6.21466 16.8999 6.0411 16.7397 6.02447 16.5318L5.14192 5.4999Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.7101c540328fb8d35b2ec4f3eba76d56.svg";
export { ForwardRef as ReactComponent };